import React, { useState } from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../components/global/modal/withModal';
import MarketingMaterialConfigurator from './MarketingMaterialConfigurator';
import WaldoficationSimplifiedUpsellModal from '../../../../../../components/global/WaldoficationSimplifiedUpsell/modal';

export const MARKETING_MATERIAL_CONFIGURATION_MODAL =
  'modal/MARKETING_MATERIAL_CONFIGURATION_MODAL';

const propTypes = {
  actionProps: PropTypes.shape({
    label: PropTypes.string,
    marketingMaterialType: PropTypes.string,
    albumFolder: PropTypes.shape({
      id: PropTypes.string,
      album_type: PropTypes.string,
      album_subtype: PropTypes.string,
    }),
  }),
  onRequestclose: PropTypes.func,
  onConfigurationComplete: PropTypes.func.isRequired,
};

const MarketingMaterialConfiguratorModal = ({
  actionProps: {
    label,
    marketingMaterialType,
    albumFolder,
    defaultConfiguration,
  } = {},
  onRequestClose,
  ...props
}) => {
  const [waldoficationUpsellOpen, setWaldoficationUpsellOpen] = useState(false);
  const onUpsellRequired = () => {
    setWaldoficationUpsellOpen(true);
  };

  return (
    <>
      <MarketingMaterialConfigurator
        label={label}
        marketingMaterialType={marketingMaterialType}
        albumFolder={albumFolder}
        onClose={onRequestClose}
        defaultConfiguration={defaultConfiguration}
        onUpsellRequired={onUpsellRequired}
        {...props}
      />
      <WaldoficationSimplifiedUpsellModal
        forceOpen={waldoficationUpsellOpen}
        actionProps={{
          albumFolderId: albumFolder.id,
          featureId: 'white_label_marketing_prints_enabled',
          onCheckoutSuccess: () => {
            setWaldoficationUpsellOpen(false);
          },
        }}
        onClose={() => {
          setWaldoficationUpsellOpen(false);
        }}
      />
    </>
  );
};

MarketingMaterialConfiguratorModal.propTypes = propTypes;

export default withModal(MarketingMaterialConfiguratorModal, {
  name: MARKETING_MATERIAL_CONFIGURATION_MODAL,
  dismissible: false,
  type: 'full',
  hideHeader: true,
  size: 'md',
});
